"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllObject = function (promises) { return new Promise(function (resolve, reject) {
    var keys = Object.keys(promises);
    var promisesArray = keys.map(function (key) { return promises[key]; });
    return Promise.all(promisesArray)
        .then(function (promiseAllResults) {
        var promiseResultsObject = keys.reduce(function (obj, key, i) {
            obj[keys[i]] = promiseAllResults[i];
            return obj;
        }, {});
        resolve(promiseResultsObject);
    })
        .catch(reject);
}); };
/**
 * Escape given string for reg exp
 *
 * @url https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
 *
 * @param {string} string
 * @return {string}
 */
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
exports.escapeRegExp = escapeRegExp;
exports.waitUntil = function (precondition, timeoutAt) {
    if (timeoutAt === void 0) { timeoutAt = 1000 * 60; }
    return new Promise(function (resolve, reject) {
        function checkNow() {
            if (precondition() === true) {
                window.clearInterval(interval);
                resolve();
                return true;
            }
        }
        var interval;
        if (checkNow() === true) {
            // make sure it doesn't register an interval if it resolves on the first go
            return;
        }
        interval = setInterval(checkNow, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject('timed out while trying to resolve a service');
        }, timeoutAt);
    });
};



//////////////////
// WEBPACK FOOTER
// ./scripts/core/utils.ts
// module id = 445
// module chunks = 0